import { gql } from '@apollo/client';

export type {
  BuyerAppointments as IBuyerAppointments,
  BuyerAppointments_buyerAppointments as IBuyerAppointment,
} from './__generated__/BuyerAppointments';

export const BUYER_APPOINTMENTS = gql`
  query BuyerAppointments {
    buyerAppointments {
      customer {
        email
        fullName
        phoneNumber
      }
      readableAddress
      scheduledTime
      state
    }
  }
`;
